export default __webpack_public_path__ + "static/media/NotoSans-Regular.bfc139fb.ttf";